import moment from 'moment'
import Vue from 'vue'

Vue.filter('toLocalTime', function (value) {
  if (value) {
    try {
      return moment.utc(new Date(value)).local().format('YYYY-MM-DD h:mm:ss a')
    } catch (error) {
      return value
    }
  }
  return value
})
